import Vue from 'vue'
import "./UI";
import App from './App.vue'
import router from './router'
import '@/assets/icon/iconfont.css'

import '@/assets/icon/iconfont.css'

//路径会有些出入）
// 引入 ElementUI
import "@/assets/css/element-variables.scss";
// 全局样式
import "@/assets/css/global.scss";
import store from './store'
import { saveAs } from 'file-saver';
import { getCookieVal } from "@/tool/index";
Vue.config.productionTip = false


  //这个方法需要放在new Vue之前，不然按F5刷新页面不会调用这个方法
  router.beforeEach(function (to, from, next) {
  
    if (getCookieVal("iyuanwu_token").length!=0||to.path=='/pointDescription') {
      if (to.meta && to.meta.title) {
        document.title = to.meta.title; // 设置页面标题
      }
      next();
    }else {
      window.location.replace(process.env.VUE_APP_LOGIN,'_self')

    }

})
new Vue({
  router,
  store,
  render: h => h(App),

}).$mount('#app')
